var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"size":_vm.icon_size}}):_vm._e(),_vm._v(" "),_c('span',{class:{'label-offset': _vm.icon}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }